import { Component, OnDestroy, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ControlsOf, FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { LoginSessionFacadeService } from '@digital-platform/users/services';

interface ForgotPassword {
  email: string;
}

@Component({
  selector: 'digital-platform-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public forgotPasswordForm: FormGroup<ControlsOf<ForgotPassword>>;
  private destroyed$ = new Subject<void>();
  public errorMsg: string;
  public submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private facade: LoginSessionFacadeService,
    private readonly router: Router
  ) {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.facade.loginSession$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((session) => {
        if (session?.user) {
          this.errorMsg = '';
        }
        if (session?.error) {
          this.errorMsg = session.error;
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onForgotPasswordSubmit() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      this.forgotPasswordForm.updateValueAndValidity();
      return;
    }
    this.submitted = true;
    const { email } = this.forgotPasswordForm.value;
    this.facade.forgotPassword(email.trim());
    this.router.navigate(['/forgot-password-submitted']);
  }

  errorHandling = (control: string, error: string) =>
    this.forgotPasswordForm.touched &&
    this.forgotPasswordForm.controls[control].hasError(error);
}
